import { call, put, select, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import { createIntl } from 'react-intl';

import * as sagaAction from './saga_action';
import Api from './api/Api';
import { setToast, clearToast } from '../actions/views/toast';
import { setPlayerSettings, clearPlayerSettings, setChapterList } from '../actions/player';
import { saveAuthToken, setCookieToken, removeAuthToken, deleteCookieToken } from '../shared/auth';
import { locale, chooseLocale } from '../translations';

const intl = createIntl({ locale, messages: chooseLocale(locale) });

export function* openToast(action) {
  // リダイレクト処理が後ろに入る場合があるので少しずらす
  yield call(delay, 1);
  yield put(setToast(action.message, action.toastType));
  yield call(delay, 8000);
  yield put(clearToast());
}

export function* postLogin(action) {
  try {
    const responseLogin = yield call(Api.postLogin, action.values);
    if (responseLogin.status === 201) {
      yield call(saveAuthToken, responseLogin.data.token);
      yield call(setCookieToken, responseLogin.data.token);
      const response = yield call(Api.getPlayerSettings);
      if (response.status === 200) {
        yield put(setPlayerSettings(response.data));
        const state = yield select();
        const playerSettings = state.reducers.player.settings;
        if (playerSettings.defaultPassword) {
          yield put(push('/password'));
        } else if (!playerSettings.nickname || !playerSettings.avatarFileName) {
          yield put(push('/profile'));
        } else {
          yield put(push('/home'));
        }
      }
    } else {
      // throw new Error('[ServerError] AccountStatus is Null');
    }
  } catch (e) {
    yield put({
      type: sagaAction.SAGA_OPEN_TOAST,
      message: intl.formatMessage({ id: 'saga.login_error_message' }),
    });
  }
}

export function* logout() {
  yield put({ type: clearPlayerSettings });
  yield call(deleteCookieToken);
  yield call(removeAuthToken);
  yield put(push('/login'));
  yield put({
    type: sagaAction.SAGA_OPEN_TOAST,
    message: intl.formatMessage({ id: 'saga.player_logout_message' }),
  });
}

export function* getPlayerSettings() {
  try {
    const response = yield call(Api.getPlayerSettings);
    if (response.status === 200) {
      yield put(setPlayerSettings(response.data));
      const state = yield select();
      const playerSettings = state.reducers.player.settings;
      if (playerSettings.disabledLogin) {
        yield put({ type: sagaAction.SAGA_POST_LOGOUT });
      }
    }
  } catch (e) {
    yield put({
      type: sagaAction.SAGA_OPEN_TOAST,
      message: intl.formatMessage({ id: 'saga.player_setting_error_message' }),
    });
    yield put(push('/login'));
  }
}

export function* getChapterList() {
  try {
    const response = yield call(Api.getChapterList);
    if (response.status === 200) {
      yield put(setChapterList(response.data));
    }
  } catch (e) {
    console.log(e);
    yield put({
      type: sagaAction.SAGA_OPEN_TOAST,
      message: intl.formatMessage({ id: 'saga.chapter_list_error_message' }),
    });
    yield put(push('/login'));
    // yield call(action.reject, new SubmissionError({ _error: 'Confirmation failed' }));
  }
}

export function* putPlayer(action) {
  try {
    const response = yield call(Api.putPlayer, action.values);
    if (response.status === 200) {
      yield put(setPlayerSettings(response.data));
      const state = yield select();
      const playerSettings = state.reducers.player.settings;
      if (playerSettings.defaultPassword) {
        yield put(push('/password'));
      } else if (!playerSettings.nickname || !playerSettings.avatarFileName) {
        yield put(push('/profile'));
      } else {
        yield put(push('/home'));
      }
    } else {
      // throw new Error('[ServerError] AccountStatus is Null');
    }
  } catch (e) {
    yield put({
      type: sagaAction.SAGA_OPEN_TOAST,
      message: intl.formatMessage({ id: 'saga.put_player_error_message' }),
    });
  }
}

function* Saga() {
  yield takeLatest(sagaAction.SAGA_OPEN_TOAST, openToast);
  yield takeLatest(sagaAction.SAGA_POST_LOGIN, postLogin);
  yield takeLatest(sagaAction.SAGA_POST_LOGOUT, logout);
  yield takeLatest(sagaAction.SAGA_GET_PLAYER_SETTINGS, getPlayerSettings);
  yield takeLatest(sagaAction.SAGA_GET_CHAPTER_LIST, getChapterList);
  yield takeLatest(sagaAction.SAGA_PUT_PLAYER, putPlayer);
}

export default Saga;
